// @flow

import React from "react";
import { localize } from "redux-i18n";
import Ajv from "ajv";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "@components";
import type { HierarchyAssignment } from "@modules/service/types";
import {
  HierarchyScopeForm,
  HierarchyScopeVAssignmentsSchema,
} from "@modules/service/components/hierarchy-scope";
import type { HierarchyTree } from "@modules/shared/reducer/hierarchy/types";

type OwnProps = $Exact<{
  assignments: Array<HierarchyAssignment>,
  hierarchy: ?HierarchyTree,
  onSubmit: (assignments: Array<HierarchyAssignment>) => void,
  onDismissHandler: () => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

type ComponentState = $Exact<{
  assignments: Array<HierarchyAssignment>,
}>;

export class UserAccountAreaOfAccessEditModal extends React.Component<Props, ComponentState> {
  validate: *;

  constructor(props: Props) {
    super(props);

    this.validate = new Ajv().compile(HierarchyScopeVAssignmentsSchema);
    this.state = {
      assignments: props.assignments,
    };
  }

  get isValid() {
    const { assignments } = this.state;
    let invalidAssignments = 0;

    // Validation should triggered against every assignment separately
    // generate invalid assignments counter that prevents trigger save
    assignments &&
      assignments.map(a => {
        const valid = this.validate(a);
        if (!valid) invalidAssignments++;
      });

    return invalidAssignments === 0;
  }

  handleSubmit = () => {
    this.props.onSubmit(this.state.assignments);
  };

  handleChanges = (data: Array<HierarchyAssignment>) => {
    this.setState({
      assignments: data,
    });
  };

  render() {
    return (
      <Modal className="modal-large">
        <ModalHeader
          className="d-flex justify-content-between"
          toggle={this.props.onDismissHandler}
        >
          {this.props.t("AREA_OF_ACCESS")}
        </ModalHeader>
        <ModalBody className="d-flex flex-column align-content-center">
          {this.props.hierarchy && this.props.assignments ? (
            <HierarchyScopeForm
              hierarchy={this.props.hierarchy}
              assignments={this.state.assignments}
              onChange={this.handleChanges}
            />
          ) : null}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onDismissHandler}>
            {this.props.t("CANCEL")}
          </Button>
          <Button
            materialIcon="replay_circle_filled"
            onClick={this.handleSubmit}
            disabled={!this.isValid}
          >
            {this.props.t("SUBMIT")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(UserAccountAreaOfAccessEditModal);
